import type { InspectorDTO } from 'src/types/inspector';

import { useTranslation } from 'react-i18next';

import { Box, Button, Typography } from '@mui/material';

export const InspectorInfoWindow = ({
  inspector,
  onSelect,
  isSelected,
}: {
  inspector: InspectorDTO;
  onSelect: () => void;
  isSelected: boolean;
}) => {
  const { t } = useTranslation('activities');
  return (
    <Box sx={{ p: 1, minWidth: 200 }}>
      <Typography variant="subtitle2" gutterBottom>
        {inspector.name}
      </Typography>
      <Typography variant="caption" display="block" color="text.secondary">
        {inspector.title || t('allocation.details.activity.inspector')}
      </Typography>
      <Typography variant="caption" display="block" color="text.secondary">
        {t('allocation.details.activity.id')} {inspector.id}
      </Typography>
      {inspector.email && (
        <Typography variant="caption" display="block" color="text.secondary">
          {t('allocation.details.activity.email')} {inspector.email}
        </Typography>
      )}
      {inspector.phone && (
        <Typography variant="caption" display="block" color="text.secondary">
          {t('allocation.details.activity.phone')} {inspector.phone}
        </Typography>
      )}
      <Box sx={{ mt: 1 }}>
        <Button
          variant="contained"
          color={isSelected ? 'inherit' : 'primary'}
          size="small"
          onClick={onSelect}
          sx={{ width: '100%' }}
        >
          {isSelected
            ? t('allocation.details.activity.removeInspector')
            : t('allocation.details.activity.selectInspector')}
        </Button>
      </Box>
    </Box>
  );
};
